// Back-to-overview: floating button that returns to the block marked as
// page overview once the visitor has scrolled past it.
export default function backToOverview() {
	const target = document.querySelector('[data-page-overview]');
	const button = document.querySelector('.back-to-overview');

	if (!target || !button) {
		return;
	}

	button.addEventListener('click', () => {
		target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		target.setAttribute('tabindex', '-1');
		target.focus({ preventScroll: true });
	});

	// Hidden attribute prevents a flash before JS runs; visibility is
	// handled through the is-visible class so it can transition.
	button.hidden = false;

	const observer = new IntersectionObserver(([entry]) => {
		const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
		button.classList.toggle('is-visible', passed);
	});

	observer.observe(target);
}
